import { useAppDispatch } from "../../../hooks/hooks";
import { useCallback } from "react";
import { downloadTestResultWideAsync } from "../../../store/dataSearchSlice";
import { useDownloadFile } from "../../../hooks/common/useDownloadFile";
import { useUtil } from "../../../util/hooks/useUtil";
import { TestResultSearchCondition } from "../../../types/dataSearch";

interface ReturnType {
  downloadTestResultWide: (_: TestResultSearchCondition) => void;
  downloadTestResultWideChunk: (_: TestResultSearchCondition) => Promise<void>;
}

export function useTestResultWideDownloader(): ReturnType {
  const dispatch = useAppDispatch();
  const { getDownloadExcelFile } = useDownloadFile();
  const { defaultErrorMessage } = useUtil();

  // 한 청크(page/size)를 엑셀 파일 1개로 저장. 전체 다운로드는 이걸 페이지 수만큼 순차 반복한다.
  // Promise 를 반환해 호출부에서 await(진행률 표시·순차 다운로드)할 수 있게 한다.
  const downloadTestResultWideChunk = useCallback(
    async (condition: TestResultSearchCondition) => {
      const page = Number((condition as unknown as Record<string, unknown>).page ?? 0);
      const size = Number((condition as unknown as Record<string, unknown>).size ?? 3000);
      // 파일명에 다운로드 범위를 표기(여러 파일을 순서대로 구분)
      const fileName = `test-result-item-wide_${page * size + 1}-${(page + 1) * size}`;
      const blob = await dispatch(downloadTestResultWideAsync(condition)).unwrap();
      getDownloadExcelFile(blob, fileName);
    },
    [dispatch, getDownloadExcelFile]
  );

  const downloadTestResultWide = useCallback(
    (condition: TestResultSearchCondition) => {
      downloadTestResultWideChunk(condition).catch(() => {
        alert(defaultErrorMessage);
      });
    },
    [downloadTestResultWideChunk, defaultErrorMessage]
  );

  return {
    downloadTestResultWide,
    downloadTestResultWideChunk,
  };
}
